export default __webpack_public_path__ + "40bd3b2a7b24f806c6285127d64bc113.png";